import { jsx as _jsx } from "react/jsx-runtime";
import { getTemplates } from "sprout-lib/dist/activities";
import { Text } from "sprout-ui-primitives";
import { Card } from "@sprout/client-components/dist/Card";
const isDev = process.env.NODE_ENV === "development";
export default function condition(activity, currentUser) {
    const { notificationType , itemType , item , rootPost  } = activity;
    const TEMPLATES = getTemplates(currentUser);
    const templateFn = TEMPLATES[notificationType];
    // Activities that have no template are not supported
    if (!templateFn && !isDev) return null;
    // Activities that are not supported
    if (notificationType === "ADDED_ITEM_TO_POST" && itemType !== "CHECKLIST_ITEM") return null;
    if (notificationType === "MOVED_ITEM" && itemType === "CHECKLIST_ITEM") return null;
    // Activities that we do not want any fallback
    // i.e. `Checklist_Item` that is deleted
    if ([
        "COMPLETED_ITEM",
        "UNCOMPLETED_ITEM",
        "ADDED_ITEM_TO_POST",
        "COMPLETED_CHECKLIST_ITEM",
        "UNCOMPLETED_CHECKLIST_ITEM",
        "DELETED_ITEM",
        "MOVED_ITEM",
        "TRANSFERRED_ITEM_IN",
        "TRANSFERRED_ITEM_OUT", 
    ].includes(notificationType) & !item) return null;
    // If the archived item parent is deleted, the archived item will also be deleted
    // which is why there will be no item, so we don't have to guard against the item's parent
    if ([
        "ADDED_ITEM_TO_TOPIC",
        "ARCHIVED_ITEM",
        "UNARCHIVED_ITEM"
    ].includes(notificationType) && !item || [
        "COMMENTED",
        "ADDED_ITEM_TO_POST"
    ].includes(notificationType) && !rootPost) return /*#__PURE__*/ _jsx(Card, {
        children: /*#__PURE__*/ _jsx(Text, {
            align: "center",
            color: "grey.400",
            children: "This activity is no longer available"
        })
    });
    return "passthrough";
};
